import formsRoutes from './forms'

export default [...formsRoutes]
